import React, { useEffect } from 'react';
import { compose, withState, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
// import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import queryString from 'query-string';

const styles = {
  grow: {
    flexGrow: 1,
    textAlign: 'center'
  },
  logoHeader: {
    height: '36px',
    marginTop: '5px'
  },
  logoHeader2: {
    marginLeft: 15,
    height: '43px'
  },
  fukuokaHeader: {
    margin: '0 auto',
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '23px'
  },
  logoPublicHeader: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
  }
};

const enhance = compose(
  withState('open', 'setOpen', false),
  withState('isFukuoka', 'setIsFukuoka', false),
  withState('isSuita', 'setIsSuita', false),
  withState('isNishiwaki', 'setIsNishiwaki', false),
  withHandlers({
    openToggleMenu: props => {
      props.setOpen(prevOpen => !prevOpen);
    },
    closeToggleMenu: props => {
      props.setOpen(false);
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  })
);

const Header = enhance(
  ({
    classes,
    isFukuoka,
    setIsFukuoka,
    isSuita,
    setIsSuita,
    isNishiwaki,
    setIsNishiwaki
  }) => {
    const url = window.location.search;
    const paramsUrl = queryString.parse(url);
    useEffect(() => {
      const link = document.querySelector("link[rel~='icon']");
      if (paramsUrl.key === 'naraigoto') {
        document.title = '福岡市子ども習い事応援事業';
        link.href = `${process.env.PUBLIC_URL}/images/logo_fukuoka_icon.png`;
        setIsFukuoka(true);
        setIsSuita(false);
        setIsNishiwaki(false);
      } else if (paramsUrl.key === 'suitanaraigoto') {
        document.title = '吹田市子供の習い事費用助成事業';
        link.href = `${process.env.PUBLIC_URL}/images/logo_suita_icon.ico`;
        setIsFukuoka(false);
        setIsSuita(true);
        setIsNishiwaki(false);
      } else if (paramsUrl.key === 'nishiwaki') {
        document.title = '西脇市こども未来応援事業';
        link.href = `${process.env.PUBLIC_URL}/images/logo_nishiwaki.ico`;
        setIsFukuoka(false);
        setIsSuita(false);
        setIsNishiwaki(true);
      } else {
        link.href = `favicon.ico`;
        setIsFukuoka(false);
        setIsSuita(false);
        setIsNishiwaki(false);
      }
    }, []);

    const getTextHeader = () => {
      let headerElement = (
        <div className={classes.logoPublicHeader}>
          <img
            alt="logo"
            src="/images/logo-manage-shop-gcms.png"
            className={classes.logoHeader}
          />
          <img
            alt="logo"
            src="/images/logo_gcms_login.png"
            className={classes.logoHeader2}
          />
        </div>
      );

      if (isFukuoka) {
        headerElement = (
          <div className={classes.fukuokaHeader}>
            福岡市子ども習い事応援事業
            <br />
            管理システム
          </div>
        );
      } else if (isSuita) {
        headerElement = (
          <div className={classes.fukuokaHeader}>
            吹田市子供の習い事費用助成事業
            <br />
            管理システム
          </div>
        );
      } else if (isNishiwaki) {
        headerElement = (
          <div className={classes.fukuokaHeader}>
            西脇市こども未来応援事業
            <br />
            管理システム
          </div>
        );
      }

      return headerElement;
    };

    return (
      <AppBar position="static">
        <Toolbar>{getTextHeader()}</Toolbar>
      </AppBar>
    );
  }
);

export default withRouter(withStyles(styles)(Header));
